var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("REGEXplorer")]),_c('RegexInput',{attrs:{"update":_vm.updateResult,"eval":_vm.evaluateExpression}}),_c('Output',{attrs:{"data":_vm.result}}),_c('Console',{attrs:{"errMsg":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }